export interface SalesContractForOrder {
  salesContractHeaderId: string;
  salesContractLineId: string;
  salesContractNumber: number;
  productId: string;
  productKey: string;
  productDescription: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureId: string;
  quantity: number;
  price: number;
  contractDetails: string;
}
